export default function WhatsAppButton() {
  const phoneNumber = '14424160576'; // Format: country code + number without special characters
  const message = encodeURIComponent('Hi! I\'m interested in booking a photo booth for my event.');

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
      aria-label="Chat on WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </button>
  );
}
